module.exports = __webpack_public_path__ + "media/bootstrap-icons/disc-11881ada.svg";